var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"left"},[_c('div',{staticClass:"leftBox"},[_c('el-tree',{attrs:{"data":_vm.navData,"node-key":"id","default-expanded-keys":_vm.default_expanded,"current-node-key":_vm.leftCurrentNode,"props":_vm.defaultProps,"check-strictly":"","highlight-current":""},on:{"node-click":_vm.handleNodeClick}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec2f4a9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/leftNav.vue
// module id = null
// module chunks = 